"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var PlanePath = function PlanePath() {
  return /*#__PURE__*/_react["default"].createElement("path", {
    id: "plane",
    d: "M5.546 1.595C5.44 1.198 5.389 1 5.832 1h.62c.123 0 .445 0 .743.496.075.125.228.424.434.825C8.233 3.5 9.29 5.56 10.153 6.7c.08.122.216.196.363.196h2.502c.371 0 .867.123 1.239.368.313.208.743.491.743.737s-.43.53-.743.737c-.372.245-.868.368-1.24.368h-2.523c-.14 0-.27.075-.341.196-.863 1.14-1.92 3.2-2.524 4.378-.206.4-.359.7-.434.825-.298.496-.62.496-.744.496h-.62c-.442 0-.39-.198-.285-.595l.038-.148c.072-.286.68-2.388 1.181-4.115.158-.543-.238-1.09-.806-1.135-.57-.046-1.13-.102-1.651-.16-.318-.036-.63.098-.81.36-.626.917-1.405 2.211-1.544 2.445-.164.278-.343.278-.412.278H1.2c-.246 0-.217-.111-.159-.334l.021-.084c.02-.08.088-.412.177-.846.158-.775.382-1.872.514-2.424.038-.159.038-.325 0-.484-.132-.552-.356-1.65-.514-2.424-.089-.434-.157-.767-.177-.846l-.02-.084c-.059-.223-.088-.334.158-.334h.343c.069 0 .248 0 .412.278.139.234.918 1.528 1.544 2.445.18.263.492.396.81.36.522-.057 1.08-.114 1.651-.16.568-.045.964-.592.806-1.135-.501-1.727-1.11-3.829-1.18-4.115l-.04-.148z"
  });
};

var _default = PlanePath;
exports["default"] = _default;